(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hegichi-virtual-try-on"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeTryOn = (root) => {
      if (!root || root.dataset.tryOnReady === 'true') return;
      root.dataset.tryOnReady = 'true';

      const input = root.querySelector('[data-try-on-input]');
      const stage = root.querySelector('[data-try-on-stage]');
      const photo = root.querySelector('[data-try-on-photo]');
      const frame = root.querySelector('[data-try-on-frame]');
      const controls = root.querySelector('[data-try-on-controls]');
      const sizeControl = root.querySelector('[data-try-on-size]');
      const xControl = root.querySelector('[data-try-on-x]');
      const yControl = root.querySelector('[data-try-on-y]');
      const rotationControl = root.querySelector('[data-try-on-rotation]');
      const resetButton = root.querySelector('[data-try-on-reset]');
      if (!input || !stage || !photo || !frame || !controls) return;

      let objectUrl = '';
      let dragStart = null;

      const applyControls = () => {
        frame.style.setProperty('--try-on-size', `${sizeControl.value}%`);
        frame.style.setProperty('--try-on-x', `${xControl.value}%`);
        frame.style.setProperty('--try-on-y', `${yControl.value}%`);
        frame.style.setProperty('--try-on-rotation', `${rotationControl.value}deg`);
      };

      const reset = () => {
        sizeControl.value = '42';
        xControl.value = '0';
        yControl.value = '0';
        rotationControl.value = '0';
        applyControls();
      };

      input.addEventListener('change', () => {
        const file = input.files && input.files[0];
        if (!file || !file.type.startsWith('image/')) return;
        if (objectUrl) URL.revokeObjectURL(objectUrl);
        objectUrl = URL.createObjectURL(file);
        photo.onload = () => {
          if (photo.naturalWidth && photo.naturalHeight) {
            stage.style.aspectRatio = `${photo.naturalWidth} / ${photo.naturalHeight}`;
          }
          stage.hidden = false;
          controls.hidden = false;
          reset();
        };
        photo.src = objectUrl;
      });

      [sizeControl, xControl, yControl, rotationControl].forEach((control) => {
        control.addEventListener('input', applyControls);
      });

      resetButton.addEventListener('click', reset);

      frame.addEventListener('pointerdown', (event) => {
        event.preventDefault();
        frame.setPointerCapture(event.pointerId);
        dragStart = {
          clientX: event.clientX,
          clientY: event.clientY,
          x: Number(xControl.value),
          y: Number(yControl.value)
        };
      });

      frame.addEventListener('pointermove', (event) => {
        if (!dragStart) return;
        const rect = stage.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        const nextX = dragStart.x + ((event.clientX - dragStart.clientX) / rect.width) * 100;
        const nextY = dragStart.y + ((event.clientY - dragStart.clientY) / rect.height) * 100;
        xControl.value = String(Math.max(-45, Math.min(45, nextX)));
        yControl.value = String(Math.max(-45, Math.min(45, nextY)));
        applyControls();
      });

      const stopDragging = (event) => {
        if (!dragStart) return;
        dragStart = null;
        if (frame.hasPointerCapture(event.pointerId)) {
          frame.releasePointerCapture(event.pointerId);
        }
      };

      frame.addEventListener('pointerup', stopDragging);
      frame.addEventListener('pointercancel', stopDragging);
      applyControls();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-hegichi-try-on]').forEach(initializeTryOn);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
